import { register } from "@rill/loader";

/**
 * Returns a list of stripe plans
 */
register(
  {
    name: "stripePlans",
    meta: ["no-bust"],
    ttl: "2 hours",
  },
  async ({ api }) => {
    const res = await (await api("stripe-plans", {})).json();
    return res.plans;
  }
);

/**
 * Returns a stripe customer
 */
register(
  {
    name: "stripeCustomer",
    meta: ["stripeCustomer"],
  },
  async ({ api }, id) => {
    const res = await (
      await api("stripe-customer", {
        query: { id },
      })
    ).json();
    return res.customer;
  }
);
